// extracted by mini-css-extract-plugin
export default {"PaginationBarContainer":"PaginationBar_PaginationBarContainer__y4W2l"};